import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';
import { ButtonColor, ButtonSize } from '@freelancer/ui/button';
import { IconSize } from '@freelancer/ui/icon';
import { FaceFilterType } from '../face-filter';
import { ModalColor } from '../modal/modal-color';
import { ModalSize } from '../modal/modal-size';
import { ModalService } from '../modal/modal.service';

@Component({
  selector: 'fl-video-record-input',
  template: `
    <fl-button
      i18n="Record video button"
      [color]="color"
      [size]="size"
      (click)="openModal()"
    >
      <fl-icon
        *ngIf="iconName"
        [name]="iconName"
        [size]="IconSize.MID"
        [flMarginRight]="'xxxsmall'"
      ></fl-icon>
      {{ ctaText }}
    </fl-button>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VideoRecordInputComponent {
  ButtonColor = ButtonColor;
  ButtonSize = ButtonSize;
  IconSize = IconSize;

  @Input() modalHeader?: string;
  @Input() modalTitle?: string;
  @Input() iconName?: string;
  @Input() color = ButtonColor.DEFAULT;
  @Input() size = ButtonSize.SMALL;
  @Input() ctaText = $localize`Record video`;
  @Input() faceFilterType: FaceFilterType = 'none';
  @Input() showCloseButton = true;
  @Input() modalColor = ModalColor.LIGHT;

  @ContentChild('contentWhileRecording')
  contentWhileRecording?: TemplateRef<any>;

  @Output() clicked = new EventEmitter<void>();
  @Output() videoRecorded = new EventEmitter<File | undefined>();

  @ContentChild('content') content?: TemplateRef<any>;
  @ContentChild('subContent')
  subContent?: TemplateRef<any>;

  constructor(private modalService: ModalService) {}

  async openModal(): Promise<void> {
    this.clicked.emit();
    const videoRecord = await this.modalService
      .open('VideoRecordModal', {
        size: ModalSize.MID,
        edgeToEdge: true,
        closeable: false,
        mobileFullscreen: true,
        color: this.modalColor,
        inputs: {
          content: this.content,
          faceFilterType: this.faceFilterType,
          subContent: this.subContent,
          modalHeader: this.modalHeader,
          modalTitle: this.modalTitle,
          contentWhileRecording: this.contentWhileRecording,
          showCloseButton: this.showCloseButton,
          mobileFullscreen: true,
        },
      })
      .afterClosed();

    this.videoRecorded.emit(videoRecord);
  }
}
